import {useState,useEffect} from 'react';
import API from "../../api/phx";

import styles from './HeaderPhone.module.scss';

export function HeaderPhoneUniversal() {
const [content,setContent] = useState('');

useEffect(() => {
  const getContent = () => {
    API.get('/content').then((result) => {
      setContent(result.data)
    });
}
getContent();
} , []);
    return (
      <div className={styles.phone}>
        <div className={styles.openingHours}>
          <b>CALL ATTRACTION TICKETS LIMITED</b>
        </div>
        <div className={styles.openingHours}>
          <b>FREE</b> {content.opening_hours}
        </div>
        <a href="tel:08004084834" className={styles.number}>{content.phone}</a>
      </div>
    )
  }